module.exports = __webpack_public_path__ + "intro.277763f4.svg";